var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59857 2.54545C7.59857 3.95127 6.45893 5.09091 5.05311 5.09091C3.6473 5.09091 2.50766 3.95127 2.50766 2.54545C2.50766 1.13964 3.6473 0 5.05311 0C6.45893 0 7.59857 1.13964 7.59857 2.54545Z",
    fill: "var(--secondary-6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.916748 9.86364V14H9.18948V9.86364C9.18948 7.57919 7.33756 5.72727 5.05311 5.72727C2.76866 5.72727 0.916748 7.57919 0.916748 9.86364Z",
    fill: "var(--secondary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFilled);
export default __webpack_public_path__ + "static/media/userFilled.dbe5489e151cb3e790640800bb1a9342.svg";
export { ForwardRef as ReactComponent };